import { Component, OnDestroy } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [LottieComponent],
})
export class LoaderComponent implements OnDestroy {
  loading: boolean = false;
  data: any = '../../assets/loader.json';
  private destroy$: Subject<void> = new Subject<void>();

  constructor(private loaderService: LoaderService) {
    this.loaderService.isLoading
      .pipe(
        delay(0), // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
        takeUntil(this.destroy$)
      )
      .subscribe(res => {
        this.loading = res;
      });
  }

  options: AnimationOptions = {
    path: 'assets/loader.json',
  };

  animationCreated(animationItem: AnimationItem): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
